export default __webpack_public_path__ + "static/media/img_05.aad946ef.jpg";